// A
import LyAccountStatus from './account-status'
// import LyAfterAll from './after-all'
// import LyAlert from './alert'
// import LyArrayToString from './array-to-string'
// B
// import LyBaohuStatus from './baohu-status'
import LyButton from './button'
// C
import LyCascader from './cascader'
import LyCascaderCheck from './cascader-check'
// import LyChartLine from './chart-line'
// import LyChartPie from './chart-pie'
// import LyCheckbox from './checkbox'
// import LyColor from './color'
import LyCombination from './combination'
// import LyCustomer from './customer'
// import LyCodeView from './code-view'
// import LyChannelDialog from './channel-dialog'
// import LyChannelAttribute from './channel-attribute'
// import LyCascaderMultiple from './cascader-multiple'

// D
// import LyDataCard from './data-card'
// import LyDataDownload from './data-download'
import LyDatepicker from './datepicker'
import LyDeleteButton from './delete-button'
import LyDialogButton from './dialog-button'
import LyDashboard from './ly-dashboard'
import LyDropdown from './dropdown'
// import LyImgDownload from './img-download'
import LyDragList from './drag-list'
// E
// import LyEditor from './editor'
// import LyExcelExport from './excel-export'
// F
import LyFileUpload from './file-upload'
import LyFileUploadForm from './file-upload-form'
import LyForm from './form'
// G
import LyG2Chart from './g2-chart'
// H
import LyHoc from './hoc'
// import LyHtml from './html'
// import LyHlfimages from './hlfimages'
// I
// import LyImgPaper from './img-paper'
// import LyImgShenhe from './img-shenhe'
// import LyImgUpload from './img-upload'
import LyInput from './input'
import LyInputNumber from './input-number'
// import LyIframe from './iframe'
// import LyInputAppendLink from './input-append-link'
//J
// import LyJinjianDialog from './jinjian-dialog'
// K
import LyKeyword from './keyword'
// import LyKeywordHelper from './keyword-helper'
// import LyKeywordTextarea from './keyword-textarea'
// L
import LyLog from './log'
// M
import LyMonthRange from './month-range'
// O
// import LyOpenButton from './open-button'
// P
import LyPage from './page'
import LyPower from './power'
// import LyPageList from './page-list'
// import LyPhoneGroup from './phone-group'
// import LyPhoneShow from './phone-show'
import LyPowerButton from './power-button'
// import LyParagraph from './paragraph'
// import LyPdfDownload from './pdf-download'
// Q
// import LyQqGroup from './qq-group'
// import LyQqShow from './qq-show'
// R
import LyRadio from './radio'
// import LyRadioGroup from './radio-group'
import LyRouteButton from './route-button'
import LyRowGroup from './row-group'
// S
import LySearchDialog from './search-dialog'
import LySearchSelect from './search-select'
import LySelect from './select'
import LyShenheStatus from './shenhe-status'
import LySubmitButton from './submit-button'
import LyShowTable from './show-table'
import LySummaryPanel from './summary-panel'
// import LySelectIndustry from './select-industry'
// import LySelectLinkage from './select-linkage'
// import LySelectGuishu from './select-guishu'
// T
import LyTable from './table'
// import LyTaocan from './taocan'
import LyTaocanPrice from './taocan-price'
import LyText from './text'
import LyTitle from './title'
// import LyTaskadd from './taskadd'
// import LyTaskaddai from './taskaddai'
// import LyTeditor from './teditor'
// import LyTortTips from './tort-tips'
// import LyTimePicker from './time-picker'
import LyTab from './tab'

// U
import LyUseStatus from './use-status'
// Z
// import LyZhanghuStatus from './zhanghu-status'


const install = function(Vue) {
    if (install.installed) return;

    Object.keys(components).forEach(key => {
        Vue.component(key, components[key]);
    });
};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

let components = {
    install,
    LyAccountStatus,
    // LyAfterAll,
    // LyAlert,
    // LyArrayToString,
    // LyBaohuStatus,
    LyButton,
    LyCascader,
    LyCascaderCheck,
    // LyChartLine,
    // LyChartPie,
    // LyCheckbox,
    // LyColor,
    LyCombination,
    // LyCustomer,
    // LyCodeView,
    // LyDataCard,
    // LyDataDownload,
    LyDatepicker,
    LyDeleteButton,
    LyDialogButton,
    LyDragList,
    LyDashboard,
    LyDropdown,
    // LyEditor,
    // LyExcelExport,
    LyFileUpload,
    LyFileUploadForm,
    LyForm,
    LyG2Chart,
    LyHoc,
    // LyHtml,
    // LyHlfimages,
    // LyImgPaper,
    // LyImgShenhe,
    // LyImgUpload,
    LyInput,
    LyInputNumber,
    // LyIframe,
    LyKeyword,
    LyLog,
    LyMonthRange,
    // LyKeywordHelper,
    // LyKeywordTextarea,
    // LyOpenButton,
    LyPage,
    LyPower,
    // LyPageList,
    // LyPhoneGroup,
    // LyPhoneShow,
    LyPowerButton,
    // LyParagraph,
    // LyQqGroup,
    // LyQqShow,
    LyRadio,
    // LyRadioGroup,
    LyRouteButton,
    LyRowGroup,
    LySearchDialog,
    LySearchSelect,
    LySelect,
    LyShenheStatus,
    LySubmitButton,
    LyShowTable,
    LySummaryPanel,
    LyTable,
    // LyTaocan,
    LyTaocanPrice,
    LyText,
    LyTitle,
    // LyTaskadd,
    // LyTaskaddai,
    // LyTeditor,
    // LyTortTips,
    LyTab,
    LyUseStatus,
    // LyZhanghuStatus,
    // LyJinjianDialog,
    // LyInputAppendLink,
    // LyChannelDialog,
    // LySelectIndustry,
    // LyTimePicker,
    // LyImgDownload,
    // LyChannelAttribute,
    // LySelectLinkage,
    // LySelectGuishu,
    // LyPdfDownload,
    // LyCascaderMultiple
}

export default components



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/ly-report.js
// module id = null
// module chunks = 